/* eslint-disable import/prefer-default-export */
import axios from 'axios';

// NOTE: Staging api doesn't have all the genres, so just pointing at production for now
export const getGenre = id =>
  axios.get(`https://api.protonradio.com/api/v2/genres/${id}`).then(({ data }) => data);
